import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './PresellOrderList.less';

export default class PresellOrderList extends OfficialPage {
  state = {
    type: 0,
    is_more: 1,
    haveData: true,
    page: 1,
    loading: false,
    orderList: [],
    formid: []
  }
  presellOrderListRefresh = false

  constructor(props) {
    super(props);
    document.title = '订单列表';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.getOrderList()
  }

  componentDidMount() {
    this.setData({
      page: 1
    })
    if (this.presellOrderListRefresh) {
      this.getOrderList()
      this.presellOrderListRefresh = false
    }
  }

  getOrderList = () => {
    var that = this,
      param = {
        show_presell_order: 2,
        page: that.data.page,
        goods_type: 0,
        page_size: 10
      }
    that.setData({
      loading: true
    })
    param.idx_arr = {
      idx: that.data.type == 7 ? 'status' : 'bargain_status',
      idx_value: that.data.type
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/orderList',
      method: 'post',
      data: param,
      success: res => {
        let rdata = res.data || []
        if (rdata.length == 0) {
          this.setData({
            haveData: false
          })
          return
        }
        let newdata = {},
          server_time = rdata[0].form_data.server_time,
          oldData = that.data.orderList || [],
          oldLen = oldData.length
        for (let i = 0; i < rdata.length; i++) {
          let f = rdata[i].form_data,
            status = f.status,
            goodsInfo = f.goods_info[0],
            presell_status,
            presell_type,
            under_sale,
            presell_shopping_cart = f.presell_shopping_cart[0],
            modelArr = goodsInfo.model_value,
            is_presell_order = f.is_presell_order,
            final_payment_start_time =
              presell_shopping_cart.final_payment_start_time * 1
          switch (is_presell_order) {
            case '1':
              switch (status) {
                case '0':
                  presell_status =
                    final_payment_start_time <= server_time ? 0 : 1 // 定金未付款,未到尾款支付时间
                  presell_type = '定金待付'
                  under_sale = true
                  break
                case '4':
                  presell_status = 6
                  presell_type = '退款审核中'
                  under_sale = false
                  break
                case '11':
                  presell_status =
                    final_payment_start_time <= server_time ? 3 : 2 //定金已付款，尾款未付款/未到尾款支付时间
                  presell_type =
                    final_payment_start_time <= server_time
                      ? '尾款待付'
                      : '定金已付'
                  under_sale = true
                  break
                case '7':
                  presell_status = f.refund_time != '0' ? 7 : 5 // 商家已退定金/订单已取消
                  presell_type =
                    f.refund_time != '0' ? '定金退款成功' : '已取消'
                  under_sale = false
                  break
                case '12':
                  presell_type = '定金超时未支付' //
                  under_sale = false
                  presell_status = 12
                  break
                case '14':
                  presell_status = 5 //商品已取消
                  presell_type = '已取消' //
                  under_sale = false
                  break
                case '15':
                  presell_status = 8 //退款失败
                  presell_type = '退款失败'
                  under_sale = false
                  break
              }
              break
            case '2':
              switch (status) {
                case '0':
                  presell_status = 3 // 定金已付款，尾款未付款
                  presell_type = '尾款待付'
                  under_sale = true
                  break
                default:
                  presell_status = 4 // 定金已付款，尾款已付款
                  presell_type = '尾款已付'
                  under_sale = false
              }
              break
            default:
              switch (status) {
                case '0':
                  presell_type = '订单待付款'
                  presell_status = 11 // 尾款阶段
                  break
                case '1':
                  presell_type = '商家待发货'
                  presell_status = 11 // 尾款阶段
                  break
                case '2':
                  presell_type = '买家待收货'
                  presell_status = 11 // 尾款阶段
                  break
                case '3':
                  presell_type = '订单待评价'
                  presell_status = 11 // 尾款阶段
                  break
                case '4':
                  presell_type = '退款审核中'
                  presell_status = 11 // 尾款阶段
                  break
                case '5':
                  presell_type = '退款中'
                  presell_status = 11 // 尾款阶段
                  break
                case '6':
                  presell_type = '订单已完成'
                  presell_status = 11 // 尾款阶段
                  break
                case '7':
                  presell_status = 11 // 尾款阶段
                  presell_type = '已退款'
                  break
                case '8':
                  presell_status = 11 // 尾款阶段
                  presell_type = '卖家待接单'
                  break
                case '15':
                  presell_status = 8 // 尾款阶段
                  presell_type = '退款失败'
                  break
                default:
                  presell_status = 4 // 定金已付款，尾款已付款
                  presell_type = '尾款已付'
                  break
              }
              under_sale = true
              break
          }
          if (
            (status == 11 || (status == 7 && is_presell_order == 1)) &&
            f.server_time > f.final_payment_end_time
          ) {
            under_sale = false
            presell_type = f.refund_time != '0' ? '退款成功' : '尾款超时未支付'
          }
          f.model_value_str =
            modelArr && modelArr.join ? modelArr.join('； ') : ''
          f.presell_status = presell_status
          f.presell_type = presell_type
          f.under_sale = under_sale
          var param_str = {
            goods_id: goodsInfo.goods_id,
            activity_id: goodsInfo.presell_activity_id || '',
            model_id: goodsInfo.model_id || '',
            nums: goodsInfo.num,
            address_id: f.address_id,
            models_text: f.model_value_str,
            models_stock: presell_shopping_cart.presell_stock_left,
            final_payment_start_time: final_payment_start_time || '',
            bargain_order_id: '',
            presell_status: presell_status,
            limit_buy: presell_shopping_cart.buy_limit_num
          }
          if (presell_status == 3 || presell_status == 4) {
            param_str.bargain_order_id = f.order_id
          }
          f.param_str = JSON.stringify(param_str)
        }
        if (param.page == 1) {
          oldData = []
        }
        newdata['orderList'] = oldData.concat(rdata)
        newdata['is_more'] = res.is_more
        newdata['haveData'] = true
        newdata['page'] = param.page + 1
        that.setData(newdata)
      },
      complete: function () {
        let newdata = {}
        newdata['loading'] = false
        that.setData(newdata)
      }
    })
  }
  changeType = e => {
    var data = e.currentTarget.dataset
    if (this.data.type == data.type) {
      return
    }
    this.setData({
      page: 1,
      is_more: 1,
      type: data.type,
      orderList: []
    })
    this.getOrderList()
  }
  gotoPresellOrder = e => {
    let presellPath =
      '/presell/pages/presellOrderDetail/presellOrderDetail?detail=' +
      e.currentTarget.dataset.orderid +
      (this.data.franchiseeId ? '&franchisee=' + this.data.franchiseeId : '')
    this.presellOrderListRefresh = true
    app.turnToPage(presellPath)
  }
  showGoodsDetail = e => {
    var orderId = e.currentTarget.dataset.orderid
    app.turnToPage(
      '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' + orderId
    )
  }
  payOrder = e => {
    var that = this,
      data = e.currentTarget.dataset,
      param_str = JSON.parse(data.paramstr),
      payorderid = data.payorderid,
      pagePath =
        '/presell/pages/presellOrderDetail/presellOrderDetail?detail=' + payorderid;
    this.presellOrderListRefresh = true
    this.saveUserFormId()
    if (payorderid) {
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: payorderid
      //   },
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = payorderid
      //     param.success = function () {
      //       setTimeout(function () {
      //         that.setData({
      //           page: 1
      //         })
      //         that.getOrderList()
      //       }, 1000)
      //     }
      //     app.wxPay(param)
      //   }
      // })
      app.goPay({
        orderId: payorderid
      });
    } else {
      app.turnToPage(pagePath)
    }
  }
  cancelOrder = e => {
    var orderId = e.target.dataset.id,
      franchisee = e.target.dataset.franchisee,
      appId = app.getAppId(),
      subShopId = franchisee == app.getAppId() ? '' : franchisee,
      that = this
    app.showModal({
      content: '你将要取消一笔付款订单，确认取消？',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirm: function () {
        that.saveUserFormId()
        app.sendRequest({
          url: '/index.php?r=AppShop/cancelOrder',
          data: {
            order_id: orderId,
            app_id: appId,
            sub_shop_app_id: subShopId || ''
          },
          success: function (res) {
            var index = that.data.currentTabIndex,
              data = {}
            data['page'] = 1
            that.setData(data)
            that.getOrderList({
              tabIndex: index
            })
          }
        })
      },
      cancel: function () { }
    })
  }
  onReachBottom = () => {
    if (this.data.is_more == 0 || this.data.loading) {
      return
    }
    this.getOrderList()
  }
  formSubmit_collect = e => {
    let formid = this.data.formid
    formid.push(e.target.formId)
  }
  saveUserFormId = callback => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        sub_shop_app_id: _this.data.franchiseeId || '',
        form_id: _this.data.formid || []
      },
      hideLoading: true,
      complete: function () {
        callback && callback()
        _this.setData({
          formid: []
        })
      }
    })
  }

  render() {
    const { type, goodsInfo, haveData, orderList, is_more } = this.state
    return (
      <div className="official-page presell-order-list">
        <TopNav title="订单列表"/>
        <div className="presell-list">
          <ScrollView className="branch-classify" scroll-x="true">
            <div className="isRelative" onClick={this.changeType} data-type="0">
              <div className={type == '0' ? 'active' : ''}>
                全部
              </div>
            </div>
            <div className="isRelative" onClick={this.changeType} data-type="1">
              <div className={type == '1' ? 'active' : ''}>
                定金待付
              </div>
            </div>
            <div className="isRelative" onClick={this.changeType} data-type="2">
              <div className={type == '2' ? 'active' : ''}>
                定金已付
              </div>
            </div>
            <div className="isRelative" onClick={this.changeType} data-type="3">
              <div className={type == '3' ? 'active' : ''}>
                尾款待付
              </div>
            </div>
            <div className="isRelative" onClick={this.changeType} data-type="4">
              <div className={type == '4' ? 'active' : ''}>
                尾款已付
              </div>
            </div>
            {/*  <view class="isRelative" catchtap='changeType' data-type="5">
                <view class="{{type == '5' ? 'active' : ''}}">退款成功
                  <form bindsubmit="formSubmit_collect" report-submit="true" class="getFormId" data-id="{{goodsInfo.id}}" data-orderid="{{goodsInfo.order_id}}" data-bargainid="{{goodsInfo.bargain_id}}">
                    <button formType="submit" hover-class="none" class='invisibleclass'></button>
                  </form>
                </view>
              </view>  */}
            <div className="isRelative" onClick={this.changeType} data-type="6">
              <div className={type == '6' ? 'active' : ''}>
                退款失败
              </div>
            </div>
            <div className="isRelative" onClick={this.changeType} data-type="7">
              <div className={type == '7' ? 'active' : ''}>
                已关闭
              </div>
            </div>
          </ScrollView>
          <div className="item-list">
            {haveData ? (
              <React.Fragment>
                {orderList.map((item, index) => {
                  return (
                    <div
                      className="item"
                      key={item.form_data.order_id}
                      onClick={this.gotoPresellOrder}
                      data-orderid={item.form_data.order_id}
                    >
                      <div className="item-tabbar">
                        <div>
                          <div>{item.form_data.add_time}</div>
                          <div>
                            <React.Fragment>{item.form_data.presell_type}</React.Fragment>
                          </div>
                        </div>
                      </div>
                      <div className="item-content">
                        <div className="image-wrap">
                          <img src={item.form_data.goods_info[0].cover} />
                        </div>
                        <div className="detail-wrap">
                          <div className="title">
                            <span>预售</span>
                            {item.form_data.goods_info[0].goods_name}
                          </div>
                          <div className="model-str">
                            {item.form_data.model_value_str}
                          </div>
                          <div className="total-price">
                            <span>
                              {'¥ ' + item.form_data.goods_info[0].price}
                            </span>
                            <span>{'X' + item.form_data.goods_info[0].num}</span>
                          </div>
                        </div>
                      </div>
                      {(item.form_data.under_sale ||
                        item.form_data.presell_status == 4) && (
                          <div className="presell-price">
                            {item.form_data.presell_status == 0 ||
                              item.form_data.presell_status == 1 ? (
                                <React.Fragment>
                                  <span>
                                    {'定金待支付：¥ ' + item.form_data.total_bargain}
                                  </span>
                                </React.Fragment>
                              ) : item.form_data.presell_status == 2 ||
                                item.form_data.presell_status == 3 ? (
                                  <React.Fragment>
                                    <span>
                                      {'定金已支付：¥ ' + item.form_data.total_bargain}
                                    </span>
                                    <span>
                                      {'尾款待支付：¥ ' +
                                        item.form_data.total_final_payment}
                                    </span>
                                  </React.Fragment>
                                ) : item.form_data.presell_status == 10 ? (
                                  <React.Fragment>
                                    <span>
                                      {'定金已支付：¥ ' + item.form_data.total_bargain}
                                    </span>
                                    <span style={convertLineStyleData('color:#999;')}>尾款超时未支付</span>
                                  </React.Fragment>
                                ) : (
                                    item.form_data.is_presell_order == 3 && (
                                      <React.Fragment>
                                        <span>
                                          {'定金已支付：¥ ' +
                                            item.form_data.total_bargain}
                                        </span>
                                        <span style={convertLineStyleData('color:#999999;')}>
                                          {'尾款已支付：¥ ' +
                                            item.form_data.total_final_payment}
                                        </span>
                                      </React.Fragment>
                                    )
                                  )}
                            {item.form_data.presell_status == 5 && (
                              <React.Fragment>
                                <span>已关闭</span>
                              </React.Fragment>
                            )}
                          </div>
                        )}
                      {item.form_data.under_sale && (
                        <div className="item-bottom">
                          {item.form_data.presell_status == 0 ||
                            item.form_data.presell_status == 1 ? (
                              <React.Fragment>
                                <div
                                  className="item-btn cancel-order"
                                  onClick={(e) => {this.cancelOrder(e);e.stopPropagation()}}
                                  data-id={item.form_data.order_id}
                                >
                                  取消订单
                                </div>
                                <div
                                  className="item-btn handsel-pay"
                                  onClick={(e) => {this.payOrder(e);e.stopPropagation()}}
                                  data-paramstr={JSON.stringify(item.form_data.param_str)} 
                                  data-payorderid={item.form_data.order_id}
                                >
                                  支付定金
                                </div>
                              </React.Fragment>
                            ) : item.form_data.presell_status == 2 ? (
                              <React.Fragment>
                                <div className="item-btn surplus-stay">
                                  未到尾款支付时间
                              </div>
                              </React.Fragment>
                            ) : item.form_data.presell_status == 3 ? (
                              <React.Fragment>
                                {
                                  item.form_data._presell_final_payment_order?
                                    (
                                      <div
                                        className="item-btn surplus-pay"
                                        onClick={(e) => {this.payOrder(e);e.stopPropagation()}}
                                        data-paramstr={JSON.stringify(item.form_data.param_str)} 
                                        data-payorderid={item.form_data._presell_final_payment_order.order_id}
                                      >支付尾款</div>
                                    )
                                    :
                                    (
                                      <div
                                        className="item-btn surplus-pay"
                                        onClick={(e) => {this.gotoPresellOrder(e);e.stopPropagation()}}
                                        data-orderid={item.form_data.order_id}
                                      >支付尾款</div>
                                    )
                                }
                              </React.Fragment>
                            ) : (
                                  item.form_data.is_presell_order == 3 && (
                                    <React.Fragment>
                                      <div style={convertLineStyleData('display:flex;justify-content:space-between;width:100%;align-item:center;')}>
                                        <span style={convertLineStyleData('font-size:24rpx;color:#999;')}>
                                          尾款支付成功，请到电商订单查看订单状态
                                  </span>
                                        <div
                                          className="show-goods-detail item-btn"
                                          onClick={(e) => {this.showGoodsDetail(e);e.stopPropagation()}}
                                          data-orderid={item.form_data.order_id}
                                        >
                                          去查看
                                  </div>
                                      </div>
                                    </React.Fragment>
                                  )
                                )}
                        </div>
                      )}
                    </div>
                  )
                })}
              </React.Fragment>
            ) : (
                <React.Fragment>
                  <div className="no-collage">
                    <div className="tip-wrap">暂无相关订单</div>
                  </div>
                </React.Fragment>
              )}
          </div>
          {is_more == 0 && (
            <div style={convertLineStyleData('padding: 15px 0;text-align: center;font-size: 12px;color: #949494;')}>
              没有更多了哦～
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/presell-order-list/PresellOrderList.jsx